export default {
  maxTimeToLiveDays: 10,
  minTimeToLiveHours: 1,
};
